import { render, staticRenderFns } from "./MenuInsightsGroupedOffline.vue?vue&type=template&id=045640fc&scoped=true&"
import script from "./MenuInsightsGroupedOffline.vue?vue&type=script&lang=js&"
export * from "./MenuInsightsGroupedOffline.vue?vue&type=script&lang=js&"
import style0 from "./MenuInsightsGroupedOffline.vue?vue&type=style&index=0&id=045640fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045640fc",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpinnerGears from 'quasar/src/components/spinner/QSpinnerGears.js';
import QBtnDropdown from 'quasar/src/components/btn-dropdown/QBtnDropdown.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import Scroll from 'quasar/src/directives/Scroll.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QIcon,QSpinnerGears,QBtnDropdown,QList,QItem,QItemSection,QItemLabel});qInstall(component, 'directives', {ClosePopup,Scroll});
